module.exports = __webpack_public_path__ + "@/assets/img/024-boy-9.a70bc728.svg";